module.exports = __webpack_public_path__ + "static/media/Informationicon01.f129c9d7.png";